import {
	GROUP_TYPE,
	CURSOR,
	getTextColor,
	GROUP_SECTION_WIDTH,
	drawRectangle,
	drawBorder,
	drawExpansionIcon,
	getTrimmedText,
	drawBorderLines,
	GROUP_SECTION_MARGIN_LEFT,
	GROUP_SECTION_PADDING_LEFT,
	GROUP_SECTION_SPACING_LEVEL_TWO,
	GROUP_SECTION_TEXT_GREY,
	GROUP_SECTION_PROJECT_BORDER_WIDTH,
	GROUP_SECTION_SPACING_LEVEL_THREE,
	GROUP_SECTION_SPACING_LEVEL_ONE,
	GROUP_SECTION_ACTION_BUTTON_SIZE,
	GROUP_SECTION_BADGE_PADDING_VERTICAL,
	GROUP_SECTION_BADGE_PADDING_HORIZONTAL,
	getFontHeight,
	GROUP_SECTION_TEXT_GREY_DARK, COMMON_IMAGE, GROUP_SECTION_EXPAND_ICON_WIDTH, GROUP_SECTION_EXPAND_ICON_HEIGHT,
} from '../../canvas-timeline/canvas_timeline_util';
import Group from '../../canvas-timeline/canvas_timeline_group';
import {PROJECT_STATUS} from '../../../../constants';
import {cacheManager} from '../../canvas-timeline/canvas_timeline_cache_manager';
import {interactionManager} from '../../canvas-timeline/canvas_timeline_interaction_manager';
import Util from '../../../../forecast-app/shared/util/util';
import {hasFeatureFlag} from "../../../../forecast-app/shared/util/FeatureUtil";

class ProjectGroup extends Group {
	constructor(data) {
		super(GROUP_TYPE.PROJECT_SCHEDULING_PROJECT, data);
	}

	refreshData(updatedProject) {
		this.data.name = updatedProject.name;
		this.data.color = updatedProject.projectColor;
		this.data.clientName = updatedProject.client ? updatedProject.client.name : null;
		this.data.status = updatedProject.status;
	}

	draw(canvasContext, x, y) {
		if (hasFeatureFlag("timeline_group_section_restyling")) {
			const width = GROUP_SECTION_WIDTH();
			const {data, height, expanded, groupType, totalHeight} = this;
			super.draw(x, y, width, height, this);
			const {clientName, name, id, color, companyProjectId, isInProjectGroup, projectGroupColor, isProjectTimeline, isFirstProjectGroup, status} = data;
			const cacheId = `${groupType}-${id}-${!!expanded}`;
			const borderThickness = 1;
			const projectGroupBorderOffsetY = isInProjectGroup ? 1 : 0;
			const schedulingTopBorderOffset = !isFirstProjectGroup && !isProjectTimeline ? 1 : 0;
			const isOpportunity = status === PROJECT_STATUS.OPPORTUNITY;
			const isPlanning = status === PROJECT_STATUS.PLANNING;
			const expandable = !isProjectTimeline || !isFirstProjectGroup;

			if (expandable) {
				interactionManager.addCursorStyleArea(x, y, width, height, CURSOR.POINTER, true);
			}

			const drawEncompassingBorder = () => {
				if (!expanded) return;
				const xOffset = data.isInProjectGroup ? 8 : 2;
				drawRectangle(
					canvasContext,
					x + GROUP_SECTION_MARGIN_LEFT,
					y + height,
					width - xOffset - 1,
					totalHeight - height,
				);
			};

			// draw left connected project border color
			if (isInProjectGroup && projectGroupColor) {
				drawBorder(
					canvasContext,
					x + GROUP_SECTION_MARGIN_LEFT - GROUP_SECTION_PROJECT_BORDER_WIDTH,
					y - 2 - (borderThickness * 2),
					height,
					true,
					projectGroupColor,
					GROUP_SECTION_PROJECT_BORDER_WIDTH,
				);
			}

			const cachedData = cacheManager.get(groupType, cacheId);
			if (cachedData) {
				canvasContext.drawImage(cachedData, x, y, width, this.itemRowHeight);
				drawEncompassingBorder();
				return;
			}

			const drawGroup = () => {
				const center = y + (height / 2);
				const topBottomBorderThickness = 1;
				const topBottomBorderWidth = isInProjectGroup
					? width - GROUP_SECTION_MARGIN_LEFT
					: width - GROUP_SECTION_MARGIN_LEFT - GROUP_SECTION_PROJECT_BORDER_WIDTH;
				const xOffset = isInProjectGroup
					? expandable ? GROUP_SECTION_SPACING_LEVEL_THREE : GROUP_SECTION_SPACING_LEVEL_TWO
					: expandable ? GROUP_SECTION_SPACING_LEVEL_TWO : GROUP_SECTION_SPACING_LEVEL_ONE;

				//Subtract 1 from width and height to make room for the grey border
				drawRectangle(
					canvasContext,
					x + GROUP_SECTION_MARGIN_LEFT,
					y,
					width - 3 - (data.isInProjectGroup ? 6 : 0),
					height - 1
				);

				// right project color
				if (!isInProjectGroup) {
					drawBorder(
						canvasContext,
						x + width - GROUP_SECTION_PROJECT_BORDER_WIDTH,
						y - 1 - (topBottomBorderThickness * 2) - schedulingTopBorderOffset,
						height + schedulingTopBorderOffset,
						true,
						color,
						GROUP_SECTION_PROJECT_BORDER_WIDTH,
					);
				}

				// expand arrow icon
				if (expandable) {
					const levelOffset = isInProjectGroup
						? expandable ? GROUP_SECTION_SPACING_LEVEL_TWO : GROUP_SECTION_SPACING_LEVEL_ONE
						: expandable ? GROUP_SECTION_SPACING_LEVEL_ONE : GROUP_SECTION_SPACING_LEVEL_ONE;
					canvasContext.drawImage(
						cacheManager.getCommonImage(expanded ? COMMON_IMAGE.EXPAND_GROUP_ICON : COMMON_IMAGE.EXPAND_GROUP_CLOSED_ICON),
						x + levelOffset - (GROUP_SECTION_EXPAND_ICON_WIDTH / 2),
						y + (height / 2) - (GROUP_SECTION_EXPAND_ICON_HEIGHT / 2),
						GROUP_SECTION_EXPAND_ICON_WIDTH,
						GROUP_SECTION_EXPAND_ICON_HEIGHT,
					);
				}

				// top border
				drawBorder(
					canvasContext,
					x + GROUP_SECTION_MARGIN_LEFT,
					y - projectGroupBorderOffsetY - schedulingTopBorderOffset,
					topBottomBorderWidth,
					false,
					'#E7E7F3',
					topBottomBorderThickness,
				);

				// bottom border
				if (!expanded && !isInProjectGroup) {
					drawBorder(
						canvasContext,
						x + GROUP_SECTION_MARGIN_LEFT,
						y - 1 + height,
						topBottomBorderWidth,
						false,
						'#E7E7F3',
						topBottomBorderThickness,
					);
				}

				//Drawing project id
				let fontSize = 10;
				canvasContext.font = `600 ${fontSize}px ` + Util.getFontFamily();
				const projectId = `P${companyProjectId}`;
				const projectIdMetrics = canvasContext.measureText(projectId);
				const projectIdWidth = projectIdMetrics.width;
				let projectIdHeight = getFontHeight(canvasContext);
				const badgeWidth = projectIdWidth + GROUP_SECTION_BADGE_PADDING_HORIZONTAL;
				const badgeHeight = projectIdHeight + GROUP_SECTION_BADGE_PADDING_VERTICAL;

				// project id background ("container")
				const projectIdBorderRadius = 4;
				drawRectangle(
					canvasContext,
					x + xOffset,
					center - (badgeHeight / 2),
					badgeWidth,
					badgeHeight,
					{
						backgroundColor: isOpportunity || isPlanning ? undefined : color,
						borderThickness: isOpportunity || isPlanning ? 2 : 0,
						borderColor: color,
						borderTopLeftRadius: projectIdBorderRadius,
						borderBottomLeftRadius: projectIdBorderRadius,
						borderTopRightRadius: projectIdBorderRadius,
						borderBottomRightRadius: projectIdBorderRadius,
					}
				);

				canvasContext.fillStyle = GROUP_SECTION_TEXT_GREY_DARK;

				// project id text
				canvasContext.fillText(
					projectId,
					x + xOffset + (badgeWidth / 2) - (projectIdWidth / 2),
					center + (badgeHeight / 2) - (projectIdHeight / 2) // + ((((fontSize / 2) + GROUP_SECTION_BADGE_PADDING_VERTICAL) / 2) / 2),
				);

				//Drawing project and client (if present) name
				fontSize = 13;
				canvasContext.font = `500 ${fontSize}px ` + Util.getFontFamily();
				const maxNameLength = GROUP_SECTION_WIDTH() - GROUP_SECTION_ACTION_BUTTON_SIZE - badgeWidth - xOffset - (GROUP_SECTION_PADDING_LEFT * 3); // subtracting padding times three to add some space
				const formattedProjectName = getTrimmedText(canvasContext, name, maxNameLength);
				const projectIdClientNameGap = 2;
				if (clientName) {
					// draw project title
					canvasContext.fillText(
						formattedProjectName,
						x + xOffset + badgeWidth + GROUP_SECTION_PADDING_LEFT,
						center - projectIdClientNameGap,
					);

					// draw client name
					canvasContext.fillStyle = GROUP_SECTION_TEXT_GREY;
					fontSize = 13;
					canvasContext.font = `400 ${fontSize}px ` + Util.getFontFamily();
					const formattedClientName = getTrimmedText(canvasContext, clientName, maxNameLength);
					canvasContext.fillText(
						formattedClientName,
						x + xOffset + badgeWidth + GROUP_SECTION_PADDING_LEFT,
						center + getFontHeight(canvasContext) - projectIdClientNameGap,
					);
				} else {
					// draw project title
					canvasContext.fillText(
						formattedProjectName,
						x + xOffset + badgeWidth + GROUP_SECTION_PADDING_LEFT,
						y + (height / 2) + (fontSize / 3)
					);
				}
			};
			drawGroup();
			drawEncompassingBorder();
		} else {
			const width = GROUP_SECTION_WIDTH();
			const {data, height, expanded, groupType, totalHeight} = this;
			super.draw(x, y, width, height, this);
			const {clientName, name, id, color, companyProjectId} = data;
			const cacheId = `${groupType}-${id}-${!!expanded}`;

			interactionManager.addCursorStyleArea(x, y, width, height, CURSOR.POINTER, true);

			const drawEncompassingBorder = () => {
				if (!expanded) return;
				const xOffset = data.isInProjectGroup ? 8 : 2;
				drawRectangle(canvasContext, xOffset, y + height - 1, width - xOffset - 1, totalHeight - height, {
					backgroundColor: color,
					borderBottomLeftRadius: 10,
				});
			};

			const cachedData = cacheManager.get(groupType, cacheId);
			if (cachedData) {
				canvasContext.drawImage(cachedData, x, y, width, this.itemRowHeight);
				drawEncompassingBorder();
				return;
			}

			const planning = [PROJECT_STATUS.PLANNING, PROJECT_STATUS.OPPORTUNITY].includes(data.status);
			const textColor = planning ? '#2a2a2a' : getTextColor(color);

			/*const drawGroup = () => {
                const cacheCanvas = createCacheCanvas(width, this.itemRowHeight);
                const context = cacheCanvas.getContext('2d');
                if (data.isInProjectGroup) {
                    context.fillStyle = data.projectGroupColor;
                    context.fillRect(8, 0, width, height);
                    context.zIndex = -1;
                }
                //Subtract 1 from width and height to make room for the grey border
                drawRectangle(context, data.isInProjectGroup ? 8 : 2, 0, width - 3 - (data.isInProjectGroup ? 6 : 0), height - 1, {
                    backgroundColor: planning ? '#ffffff' : color,
                    borderColor: color,
                    borderThickness: planning ? 2 : 0,
                    borderTopLeftRadius: 10,
                    borderBottomLeftRadius: expanded ? 0 : 10
                });
                drawExpansionIcon(context, 0, 0, width, height, {
                    backgroundColor: planning ? undefined : color,
                    expanded
                });
                if (!data.isInProjectGroup) {
                    drawBorderLines(context, 0, 0, width, height, false);
                } else if (expanded) {
                    drawBorderLines(context, 8, 0, width, height, false);
                } else {
                    drawBorderLines(context, 8, 0, width, height, false, data.projectGroupColor);
                }

                context.fillStyle = textColor;
                //Drawing project id
                context.font = '700 10px ' + Util.getFontFamily();
                context.fillText(`P${companyProjectId}`, 16, clientName ? 17 : 24);

                //Drawing project and client (if present) name
                context.font = '500 12px ' + Util.getFontFamily();
                const formattedProjectName = getTrimmedText(context, name);
                if (clientName) {
                    context.fillText(formattedProjectName, 52, 18);
                    context.font = '400 11px ' + Util.getFontFamily();
                    const formattedClientName = getTrimmedText(context, clientName);
                    context.fillText(formattedClientName, 52, 33);
                } else {
                    context.fillText(formattedProjectName, 52, 25);
                }
                cacheManager.set(groupType, cacheId, cacheCanvas);
                canvasContext.drawImage(cacheCanvas, x, y, width, this.itemRowHeight);
            };*/
			const drawGroup = () => {
				if (data.isInProjectGroup) {
					canvasContext.fillStyle = data.projectGroupColor;
					canvasContext.fillRect(x + 8, y + 0, width, height);
					canvasContext.zIndex = -1;
				}
				//Subtract 1 from width and height to make room for the grey border
				drawRectangle(canvasContext, x + (data.isInProjectGroup ? 8 : 2), y, width - 3 - (data.isInProjectGroup ? 6 : 0), height - 1, {
					backgroundColor: planning ? '#ffffff' : color,
					borderColor: color,
					borderThickness: planning ? 2 : 0,
					borderTopLeftRadius: 10,
					borderBottomLeftRadius: expanded ? 0 : 10,
				});
				drawExpansionIcon(canvasContext, x, y, width, height, {
					backgroundColor: planning ? undefined : color,
					expanded,
				});
				if (!data.isInProjectGroup) {
					drawBorderLines(canvasContext, x, y, width, height, false);
				} else if (expanded) {
					drawBorderLines(canvasContext, x + 8, y, width, height, false);
				} else {
					drawBorderLines(canvasContext, x + 8, y, width, height, false, data.projectGroupColor);
				}

				canvasContext.fillStyle = textColor;
				//Drawing project id
				canvasContext.font = '700 10px ' + Util.getFontFamily();
				canvasContext.fillText(`P${companyProjectId}`, x + 16, y + (clientName ? 17 : 24));

				//Drawing project and client (if present) name
				canvasContext.font = '500 12px ' + Util.getFontFamily();
				const formattedProjectName = getTrimmedText(canvasContext, name);
				if (clientName) {
					canvasContext.fillText(formattedProjectName, x + 52, y + 18);
					canvasContext.font = '400 11px ' + Util.getFontFamily();
					const formattedClientName = getTrimmedText(canvasContext, clientName);
					canvasContext.fillText(formattedClientName, x + 52, y + 33);
				} else {
					canvasContext.fillText(formattedProjectName, x + 52, y + 25);
				}
			};
			drawGroup();
			drawEncompassingBorder();
		}
	}
}

export default ProjectGroup;
